import type { DeepPartial } from '@luna/utils-ts';

import type {
    SharedShorthandTransactionsFeatures,
    SharedTransactionsFeatures,
} from '../../types/SharedTransactionsFeatures';

export const features: DeepPartial<SharedTransactionsFeatures> = {
    creditCardFilter: {
        enabled: true,
    },
    variableSymbolFilter: {
        enabled: true,
    },
    startingAndEndingBalance: {
        enabled: true,
    },
    history: {
        initialBalanceAvailabilityAlert: {
            enabled: true,
        },
        initialBalancePrintExport: {
            enabled: true,
        },
    },
};

export const shorthandFeatures: DeepPartial<SharedShorthandTransactionsFeatures> = {};
